import React, { useState } from "react";
import Config from "../../../config";
import { MediaModel } from "../../../models/conversations";
import { MediaType } from "../../../models/media.models";
import Audio from "./audio.component";
import File from "./file.component";
import ImageComponent from "./image.component";
import Video from "./video.component";
import ViewFullMedia from "./view-full-media.component";
import { FileService } from "../../../services/FileService";

interface Props {
    SenderName: string;
    Media: MediaModel;
}

const MediaComponent = (props: Props) => {

    const { SenderName, Media } = props;
    const [openMedia, setOpenMedia] = useState<boolean>(false)

    const mediaDisplay = () => {
        setOpenMedia(true)
    }

    const mediaClose = () => {
        setOpenMedia(false)
    }

    const getMediaComponent = (type: string) => {
        var src = Media.ID ? `${Config.API_URL}/api/File/${Media.ID}/view` : Media.Url;
        if (type != null) {
            const mediatype = type.split('/')[0];
            switch (mediatype) {
                case MediaType.IMAGE:
                case MediaType.IMAGE_JPEG:
                case MediaType.IMAGE_ARW:
                case MediaType.IMAGE_PNG:
                case MediaType.IMAGE_GIF:
                case MediaType.IMAGE_WEBP:
                    return <ImageComponent MediaUrl={src} classname={"display-media"} fileDownload={() => FileService.fileDownload(props.Media)} mediaDisplay={mediaDisplay} />
                case MediaType.VIDEO:
                    return <Video MediaUrl={src} controls={true} mediaDisplay={mediaDisplay} />
                case MediaType.AUDIO:
                    return <Audio MediaUrl={src} controls={true} />
                default:
                    return <File media={Media} fileDownload={() => FileService.fileDownload(Media)} cross={false} />
            }
        }
    }
    return (
        <>
            <div className={`c-pointer mb-1`}>
                {getMediaComponent(Media.ContentType)}
            </div>
            {
                openMedia &&
                <ViewFullMedia media={Media} open={openMedia} senderName={SenderName} onClose={mediaClose} fileDownload={() => FileService.fileDownload(Media)} />
            }
        </>
    )
}

export default MediaComponent